import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SidebarBranchesContainerProps } from "../../../../interfaces/containers";
import Sidebar from "../../../../pages/Profile/Branches/Sidebar";
import { 
    getBranches, 
    cleanBranches, 
    addBranch, 
    cleanAddBranch, 
    editBranch, 
    cleanEditBranch, 
    deleteBranch, 
    cleanDeleteBranch,
    getRegions,
    getCities,
    getCommunes,
} from "../../../../actions/profile";

function mapStateToProps(state: SidebarBranchesContainerProps) {
    return {
        user: state.auth.user,
        branches: state.profile.branches,
        regions: state.profile.regions,
        cities: state.profile.cities,
        communes: state.profile.communes
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getBranches,
        cleanBranches,
        addBranch, 
        cleanAddBranch, 
        editBranch, 
        cleanEditBranch, 
        deleteBranch, 
        cleanDeleteBranch,
        getRegions,
        getCities,
        getCommunes,
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);